







































import { Component, Vue } from 'vue-property-decorator'
import echarts from 'echarts'
import moment from 'moment'
import { statistics } from '@/apps/open/services/weboffice'
@Component({
  components: {}
})
export default class ApiUsage extends Vue {
  periodOptions = [
    {
      label: '按日',
      value: 'daterange'
    },
    {
      label: '按月',
      value: 'monthrange'
    }
  ];

  date: any = []
  period: string = 'daterange'

  columns = [
    {
      prop: 'date',
      label: '统计日期',
      // minWidth: 180,
      align: 'left'
    },
    {
      prop: 'max_online_files',
      label: '同时打开文件数',
      // minWidth: 80,
      align: 'left'
    }
  ];

  cTimePickerOptions = {
    onPick: (dateRange: any) => {
    },
    disabledDate: (time: Date) => {
      return (
        moment(time) > moment(new Date()).subtract(1, 'day') || moment(time) < moment(new Date()).subtract(13, 'month')
      )
    }
  };

  orderList = [];
  loading = false;
  app_id = ''

  get curEnterprise () {
    return this.$store.getters['User/curEnterprise']
  }

  async mounted () {
    this.app_id = this.$route.params['id']
    this.onSelectPeriodChange()
  }

  async onSelectPeriodChange () {
    if (this.period === 'daterange') {
      this.date = [new Date(new Date().setDate(new Date().getDate() - 8)), new Date(new Date().setDate(new Date().getDate() - 1))]
    } else {
      this.date = [new Date(new Date().setMonth(new Date().getMonth() - 6)), new Date()]
    }
    this.createChart()
  }

  async onSelectDateChange () {
    this.createChart()
  }

  async createChart () {
    const div = document.getElementById('chart') as HTMLDivElement
    const chart = echarts.init(div)

    // @ts-ignore
    chart.showLoading({
      text: '暂无数据',
      color: '#ffffff',
      textColor: '#8a8e91',
      maskColor: 'rgba(255, 255, 255, 0.8)'
    }
    )
    let from = ''; let to = ''
    if (this.period === 'daterange') {
      from = moment(this.date[0]).format('YYYY-MM-DD')
      to = moment(this.date[1]).format('YYYY-MM-DD')
    } else {
      from = moment(this.date[0]).format('YYYY-MM')
      to = moment(this.date[1]).format('YYYY-MM')
    }

    const resp = await statistics(this.app_id, this.period === 'daterange' ? 'day' : 'month', from, to, this.curEnterprise.developer_id)
    let date = []
    let files = []
    let max_online_files = []
    let pages = []
    let users = []
    this.orderList = resp.data.data
    for (let i in resp.data.data) {
      let d = resp.data.data[i]
      date.push(d.date)
      files.push(d.files)
      max_online_files.push(d.max_online_files)
      pages.push(d.pages)
      users.push(d.users)
    }

    // @ts-ignore
    let optionData = {
      // 定义样式和数据
      // backgroundColor: '#FBFBFB',
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        x: 'center',
        y: 'bottom',
        data: ['同时打开文件数']
      },

      calculable: true,

      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: date
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#CECECE'
            }
          }
        }
      ],
      series: [
        {
          name: '同时打开文件数',
          type: 'line',
          // symbol: 'none',
          //  smooth: 0.3,
          color: ['#2E68F8'],
          data: max_online_files
        }
      ]
      //   grid: {
      //     // x: 20,
      //     // y: 30,
      //     // x2: 0,
      //     // y2: 50
      //   }
    }

    chart.clear()
    // @ts-ignore
    chart.setOption(optionData)
    if (max_online_files.length > 0) {
      chart.hideLoading()
    }
  }
}
